
import { defineComponent, PropType } from 'vue'
import SettingPanel from '@/views/fuzoku-meisai/SettingPanel.vue'
import { ResponseSettingItem } from '@/repositories/keiei-joho/data'
import { KeieiJokyoUiItem } from '@/views/keiei-joho/data'

export default defineComponent({
  components: {
    SettingPanel
  },
  props: {
    item: {
      type: Object as PropType<KeieiJokyoUiItem>,
      required: true
    }
  },
  emits: {
    changeInput: (item: KeieiJokyoUiItem) => true
  },
  setup (props, { emit }) {
    const onUpdateKmk = (panelName: string, item: ResponseSettingItem) => {
      const propItem: KeieiJokyoUiItem = props.item
      propItem.item.setting = item
      emit('changeInput', propItem)
    }

    return {
      onUpdateKmk
    }
  }
})
